"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.License = void 0;
var constants_1 = require("../constants");
var License = /** @class */ (function () {
    function License(license) {
        if (license === void 0) { license = {}; }
        Object.assign(this, license);
    }
    License.prototype.typeOfCurriculumIs = function (CurriculumId) {
        var _a;
        return (_a = this.curriculum) === null || _a === void 0 ? void 0 : _a.id.startsWith(CurriculumId);
    };
    License.prototype.hasCurriculum = function (curriculum) {
        return this.curriculum && this.curriculum.id === curriculum;
    };
    License.prototype.hasProduct = function (productId) {
        return this.product && this.product.id === productId;
    };
    License.prototype.isDigitalLicensed = function () {
        var _a;
        return ((_a = this.product) === null || _a === void 0 ? void 0 : _a.id) === constants_1.ProductId.Digital;
    };
    return License;
}());
exports.License = License;
